/* eslint-disable jsx-a11y/anchor-is-valid */
import type { FC } from "react";
import {
  Avatar,
  DarkThemeToggle,
  Dropdown,
  Label,
  Modal,
  Navbar,
  Radio,
  useThemeMode,
} from "flowbite-react";
import {
  HiMenuAlt1,
  HiSearch,
  HiX,
} from "react-icons/hi";
import { useSidebarContext } from "../context/SidebarContext";
import isSmallScreen from "../helpers/is-small-screen";
import Notifications from "./Notifications";
import Global from "../globals/globals";
import { useState, useContext } from "react";
import { ChatContext, ChatContextInterface } from "./MSRContext";
import { Link, useNavigate } from "react-router-dom";
import { constants } from "buffer";
import Requests from "./Requests";

const ExampleNavbar: FC = function () {
  const { isOpenOnSmallScreens, isPageWithSidebar, setOpenOnSmallScreens } =
    useSidebarContext();
  const { mode } = useThemeMode();

  return (
    <Navbar fluid>
      <div className="w-full p-3 lg:px-5 lg:pl-3">
        <div className="flex items-center justify-between">
          <div className="flex items-center">
            {isPageWithSidebar && (
              <button
                onClick={() => setOpenOnSmallScreens(!isOpenOnSmallScreens)}
                className="p-2 mr-3 text-gray-600 rounded cursor-pointer hover:bg-gray-100 hover:text-gray-900 dark:text-gray-400 dark:hover:bg-gray-700 dark:hover:text-white lg:inline"
              >
                <span className="sr-only">Toggle sidebar</span>
                {isOpenOnSmallScreens && isSmallScreen() ? (
                  <HiX className="w-6 h-6" />
                ) : (
                  <HiMenuAlt1 className="w-6 h-6" />
                )}
              </button>
            )}
            {/* React‑Router Link yerine href kullanmayın */}
            <Navbar.Brand as={Link} to="/" className="flex items-center">
              <img
                alt=""
                src={mode === 'dark' ? "/images/whiteicont.png" : "/images/icont.png"}
                style={{
                  width: "140px",
                  height: "auto",
                  maxWidth: "none",
                  maxHeight: "none",
                  display: "block",
                }}
                className="sm:h-6 sm:w-10"
              />
            </Navbar.Brand>
          </div>
          <div className="flex items-center lg:gap-3">
            <div className="flex items-center">

              <Requests/>
              <Notifications />
              <DarkThemeToggle />
            </div>
            <div className=" block">
              <UserDropdown />
            </div>
          </div>
        </div>
      </div>
    </Navbar>
  );
};

const UserDropdown: FC = function () {
  const { currentMode, handlePublishEvent, wrapper } = useContext(ChatContext) as ChatContextInterface;
  const [ismodeWindow, setModeWindow] = useState(false);
  const { setWrapper, setIsAuthenticated } = useContext(ChatContext) as ChatContextInterface;
  const navigate = useNavigate();
  const closeModeWindow = () => {
    setModeWindow(false);
  };
  const handleChangeMode = () => {
    setModeWindow(true);
  };

  return (
    <div>
      <Dropdown
  arrowIcon={false}
  inline
  label={
    <span className="relative inline-block">
      <span className="sr-only">User menu</span>
      <Avatar
        alt=""
        img="../images/users/thomas-lean.png"
        rounded
        size="sm"
      />
      {/* Status Indicator */}
      <span
        className={`absolute bottom-0 right-0 h-3 w-3 rounded-full border-2 border-white ${
          currentMode === "available" ? "bg-green-500" : "bg-red-500"
        }`}
      ></span>
    </span>
  }
>

        <Dropdown.Header>
          <span className="block text-sm">{Global.username}</span>
        </Dropdown.Header>
        <Dropdown.Item as={Link} to="/settings">Settings</Dropdown.Item>
        <Dropdown.Item onClick={handleChangeMode}>Change Mode</Dropdown.Item>
        <Dropdown.Divider />
        <Dropdown.Item
          onClick={() => {
            sessionStorage.clear();
            wrapper?.closeConnection();
            localStorage.clear();
            setWrapper(null);
            navigate("/login", { replace: true });
            window.location.reload();
          }}
        >
          Log out
        </Dropdown.Item>
      </Dropdown>
      <Modal
        onClose={closeModeWindow}
        popup
        show={ismodeWindow}
        size="xl"
        theme={{
          content: {
            inner:
              "relative flex max-h-[90vh] flex-col rounded-lg bg-white shadow dark:bg-gray-800",
          },
        }}
      >
        <Modal.Header>
          Change your mode:
        </Modal.Header>
        <Modal.Body className="flex flex-col gap-5 mt-2 pt-2">
          {["available", "break", "help-req"].map((event) => (
            <div className="flex items-center gap-2" key={event}>
              <Radio
                id={event}
                name="status"
                checked={currentMode === event}
                onChange={() => handlePublishEvent(event)}
              />
              <Label htmlFor={event}>
                {event.charAt(0).toUpperCase() + event.slice(1)}
              </Label>
            </div>
          ))}
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default ExampleNavbar;
